// Danh sách ngôn ngữ cố định thay vì lấy từ API
export const languageList = [
  { key: 'af', name: 'Afrikaans' },
  { key: 'ar', name: 'Arabic' },
  { key: 'bn', name: 'Bengali' },
  { key: 'zh', name: 'Chinese Simplified' },
  { key: 'zh-TW', name: 'Chinese Traditional' },
  { key: 'en', name: 'English' },
  { key: 'tl', name: 'Filipino' },
  { key: 'fr', name: 'French' },
  { key: 'de', name: 'German' },
  { key: 'ha', name: 'Hausa' },
  { key: 'hi', name: 'Hindi' },
  { key: 'id', name: 'Indonesian' },
  { key: 'it', name: 'Italian' },
  { key: 'ja', name: 'Japanese' },
  { key: 'km', name: 'Khmer' },
  { key: 'ko', name: 'Korean' },
  { key: 'lo', name: 'Lao' },
  { key: 'ms', name: 'Malay' },
  { key: 'mm', name: 'Myanmar' },
  { key: 'pt', name: 'Portuguese' },
  { key: 'ru', name: 'Russian' },
  { key: 'es', name: 'Spanish' },
  { key: 'sw', name: 'Swahili' },
  { key: 'th', name: 'Thai' },
  { key: 'tr', name: 'Turkish' },
  { key: 'ur', name: 'Urdu' },
  { key: 'vi', name: 'Vietnamese' }
];

// Hàm trả về danh sách ngôn ngữ (không gọi API)
export const LangList = () => {
  return Promise.resolve(languageList);
};

/** BCP 47: tl → fil, mm → my (đồng bộ với SSR / lib/seo/metadata.js) */
export const HREFLANG_CODE_MAP = {
  mm: "my",
  tl: "fil"
};

export const toHrefLangCode = (language) => HREFLANG_CODE_MAP[language] || language;

/** Open Graph locale (og:locale), không dùng mã ngôn ngữ 2 ký tự */
export const OG_LOCALE_BY_LANGUAGE = {
  vi: "vi_VN",
  en: "en_US",
  ja: "ja_JP",
  ko: "ko_KR",
  zh: "zh_CN",
  "zh-TW": "zh_TW",
  fr: "fr_FR",
  de: "de_DE",
  es: "es_ES",
  it: "it_IT",
  pt: "pt_BR",
  ru: "ru_RU",
  ar: "ar_AR",
  hi: "hi_IN",
  id: "id_ID",
  ms: "ms_MY",
  th: "th_TH",
  km: "km_KH",
  lo: "lo_LA",
  mm: "my_MM",
  af: "af_ZA",
  bn: "bn_BD",
  tl: "fil_PH",
  ha: "ha_NG",
  sw: "sw_KE",
  tr: "tr_TR",
  ur: "ur_PK"
};

export const toOgLocale = (language) => {
  if (!language) return "en_US";
  const raw = String(language).trim();
  const key = raw.toLowerCase() === "zh-tw" ? "zh-TW" : raw;
  return OG_LOCALE_BY_LANGUAGE[key] || OG_LOCALE_BY_LANGUAGE[raw.toLowerCase()] || "en_US";
};